<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ucoQcl/tc-custom/9781771423489.jpg?1704825568614" alt="This image is the cover for the book Brief History of the Earth's Climate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brief History of the Earth's Climate
      </h1>
      <p class="bookDescription body article font2">
        <b>“Give[s] . . . policymakers and concerned citizens a more thorough understanding of climate science and renewed conviction . . . on leaving fossil fuels behind.” —Tom Green, Senior Climate Policy Advisor, David Suzuki Foundation</b><br/><br/><i>A Brief History of the Earth’s Climate</i> is an accessible guide to the natural evolution of the Earth’s climate over 4.6 billion years, and how and why human-caused global warming is different and much more dangerous.<br/><br/>Richly illustrated chapters cover the major historical climate change processes including evolution of the sun, plate motions and continental collisions, volcanic eruptions, changes to major ocean currents, Earth’s orbital variations, sunspot variations, and short-term ocean current cycles. There is also an overview of the implications of the COVID pandemic for climate change. Content includes:Understanding natural geological processes that shaped the climateHow human impacts are now rapidly changing the climateTipping points and the unfolding climate crisisWhat we can do to limit the damage to the planet and ecosystemsCountering climate myths peddled by climate change science deniers.<br/><br/><i>A Brief History of the Earth’s Climate</i> is essential reading for everyone who is looking to understand what drives climate change, counter skeptics and deniers, and take action on the climate emergency.<br/><br/>“Earle understands the big climate picture and paints it with exceptional clarity.” —James Hansen, director, Climate Science, Awareness and Solutions, Columbia University Earth Institute<br/><br/>Steven Earle’s innate story-telling ability, coupled with his remarkable talent for making complex scientific information accessible, makes this page-turner a must-read for anyone seeking to understand the Earth’s climate system.” —Andrew Weaver, University of Victoria, lead author, Intergovernmental Panel on Climate Change
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven Earle
      </h2>
      
      <p class="authorDescription body article"><P><B>Steven Earle</B>, PhD, has taught university Earth Science for almost four decades and is author of the widely used textbook, <I>Physical Geology</I>. He participates in climate change research and community engagement with climate change solutions in the areas of transport and land stewardship on Gabriola Island, Canada, where he lives with his family. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Society Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fb96bbf2